// src/pages/About.js
import React, { forwardRef } from "react";
import { Box, Heading, Text, Image, Flex, VStack } from "@chakra-ui/react";
import roundtableImage from "../assets/images/rt/roundtable.webp";

const About = forwardRef((props, ref) => {

  return (
    <Box ref={ref} p={20} bg="#5f9482" {...props}>
      <Flex
        direction={{ base: "column", md: "row" }}
        align="center"
        justify="space-between"
      >
        {/* Venstre kolonne med tekst */}
        <VStack spacing={4} align="flex-start" flex="1">
          <Heading as="h2" size="lg" fontWeight="thin" color="white">
            OM VANGEN WOOD
          </Heading>
          <Text fontSize="lg" color="white">
            Jeg er opptatt av å lage høykvalitets møbler i tre
            som forener tradisjon med moderne estetikk. Mine håndlagde møbler er laget med
            de kvalitetsmaterialer, noe som sikrer både holdbarhet og et tidløst design.
          </Text>
          <Text fontSize="md" color="white">
            Hvert produkt er nøye designet og laget med nøyaktighet.
            Målet er å tilføre hjemmet ditt varme og eleganse med møbler som varer i generasjoner.
          </Text>
        </VStack>
        {/* Høyre kolonne med bilde */}
        <Box flex="1" ml={{ base: 0, md: 10 }} mt={{ base: 10, md: 0 }}>
          <Image
            src={roundtableImage}
            alt="Roundtable"
            borderRadius="md"
            maxW={{ base: "100%", md: "600px" }}
            boxShadow="md"
          />
        </Box>
      </Flex>
    </Box>
  );
});

export default About;